import {Assignment, ServiceType} from '@features/assignment/types.ts'
import {useTranslation, TKey} from '@/translations/i18n.tsx'
import {formatLocaleDate} from '@/dates.ts'
import {Button} from '@components/ui/button'
import {useState} from 'react'
import {ScheduleModal} from '@features/assignment/components/schedule-modal'
import {Spinner} from '@components/ui/spinner'
import {useHostResponsive} from '@features/assignment/queries/useHostResponsive'
import {
    ASSIGNMENT_DESCRIPTION_PARAGRAPH_CLASSNAME,
    ASSIGNMENT_DESCRIPTION_TEXT_CLASSNAME,
    ASSIGNMENT_DESCRIPTION_TITLE_CLASSNAME,
    ASSIGNMENT_DESCRIPTION_WRAPPER_CLASSNAME
} from '@features/assignment/constants'

export const AcceptedHostUnresponsiveDescription = ({
    assignment,
    serviceType
}: {
    assignment: Assignment
    serviceType: ServiceType
}) => {
    const {t} = useTranslation()
    const [isScheduleModalOpen, setIsScheduleModalOpen] = useState(false)
    const contactHostMutation = useHostResponsive({assignmentId: assignment.id, taskId: assignment.task.id})

    return (
        <div className={ASSIGNMENT_DESCRIPTION_WRAPPER_CLASSNAME}>
            <div className={ASSIGNMENT_DESCRIPTION_TEXT_CLASSNAME}>
                <h3 className={ASSIGNMENT_DESCRIPTION_TITLE_CLASSNAME}>
                    {t('assignment:descriptions:accepted_host_unresponsive:title', {
                        date: assignment.host_unresponsive_at
                            ? formatLocaleDate(assignment.host_unresponsive_at, 'PPP')
                            : '-'
                    })}
                </h3>
                <p className={ASSIGNMENT_DESCRIPTION_PARAGRAPH_CLASSNAME}>
                    {t(`assignment:descriptions:accepted_host_unresponsive:paragraph1:${serviceType}` as TKey)}
                </p>
                <p className={ASSIGNMENT_DESCRIPTION_PARAGRAPH_CLASSNAME}>
                    {t(`assignment:descriptions:accepted_host_unresponsive:paragraph2:${serviceType}` as TKey, {
                        date: assignment.cancellation_date ? formatLocaleDate(assignment.cancellation_date, 'PPP') : '-'
                    })}
                </p>
            </div>
            <div className="flex gap-4">
                <Button
                    variant="secondary"
                    onClick={() => contactHostMutation.mutate()}
                    disabled={contactHostMutation.isPending}
                >
                    {t('assignment:descriptions:accepted_host_unresponsive:host_contacted_me')}
                    {contactHostMutation.isPending && <Spinner size={20} />}
                </Button>
                <Button disabled={contactHostMutation.isPending} onClick={() => setIsScheduleModalOpen(true)}>
                    {t('assignment:descriptions:schedule')}
                </Button>
            </div>
            {isScheduleModalOpen && (
                <ScheduleModal
                    assignment={assignment}
                    serviceType={serviceType}
                    onClose={() => setIsScheduleModalOpen(false)}
                />
            )}
        </div>
    )
}
